const ITEMS = ["Websites designed to be seen", "Experiences designed to be remembered", "Bangalore, India", "Design · Development · Experience", "Thoughtful. Responsive. Purposeful."];

export const Marquee = ({ dark = false }) => (
  <div data-testid="editorial-marquee" className={`overflow-hidden border-y py-6 ${dark ? "bg-charcoal border-ivory/10 text-ivory/70" : "bg-ivory border-taupe-line text-charcoal/80"}`} aria-hidden>
    <div className="flex w-max animate-marquee will-change-transform hover:[animation-play-state:paused]">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0">
          {ITEMS.map((t, i) => (
            <span key={i} className="flex items-center gap-10 pr-10 font-serif text-2xl sm:text-3xl font-light tracking-tight whitespace-nowrap">
              {t}
              <span className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-gold/70" : "bg-sage"}`} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
